import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#6366F1", // Modern indigo
      light: "#818CF8",
      dark: "#4F46E5",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#F59E0B", // Warm amber
      light: "#FBBF24",
      dark: "#D97706",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#FAFAFA",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#1F2937",
      secondary: "#6B7280",
    },
    grey: {
      50: "#F9FAFB",
      100: "#F3F4F6",
      200: "#E5E7EB",
      300: "#D1D5DB",
      400: "#9CA3AF",
      500: "#6B7280",
      600: "#4B5563",
      700: "#374151",
      800: "#1F2937",
      900: "#111827",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Exo 2", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 800,
      letterSpacing: "-0.025em",
    },
    h2: {
      fontFamily: '"Exo 2", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 700,
      letterSpacing: "-0.025em",
    },
    h3: {
      fontFamily: '"Exo 2", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 600,
      letterSpacing: "-0.025em",
    },
    h4: {
      fontFamily: '"Exo 2", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 600,
      letterSpacing: "-0.025em",
    },
    h5: {
      fontFamily: '"Exo 2", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 500,
      letterSpacing: "-0.025em",
    },
    h6: {
      fontFamily: '"Exo 2", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 500,
      letterSpacing: "-0.025em",
    },
    button: {
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      textTransform: "none",
      fontSize: 15,
      fontWeight: 600,
      letterSpacing: "0.025em",
    },
    body1: {
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 400,
      lineHeight: 1.7,
      letterSpacing: "0.02em",
    },
    body2: {
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 400,
      lineHeight: 1.6,
      letterSpacing: "0.02em",
    },
  },
  shape: {
    borderRadius: 12,
  },
  shadows: [
    "none",
    "0px 2px 4px rgba(0, 0, 0, 0.05)",
    "0px 4px 8px rgba(0, 0, 0, 0.1)",
    "0px 8px 16px rgba(0, 0, 0, 0.1)",
    "0px 12px 24px rgba(0, 0, 0, 0.15)",
    "0px 16px 32px rgba(0, 0, 0, 0.2)",
    "0px 20px 40px rgba(0, 0, 0, 0.25)",
    "0px 24px 48px rgba(0, 0, 0, 0.3)",
    "0px 28px 56px rgba(0, 0, 0, 0.35)",
    "0px 32px 64px rgba(0, 0, 0, 0.4)",
    "0px 36px 72px rgba(0, 0, 0, 0.45)",
    "0px 40px 80px rgba(0, 0, 0, 0.5)",
    "0px 44px 88px rgba(0, 0, 0, 0.55)",
    "0px 48px 96px rgba(0, 0, 0, 0.6)",
    "0px 52px 104px rgba(0, 0, 0, 0.65)",
    "0px 56px 112px rgba(0, 0, 0, 0.7)",
    "0px 60px 120px rgba(0, 0, 0, 0.75)",
    "0px 64px 128px rgba(0, 0, 0, 0.8)",
    "0px 68px 136px rgba(0, 0, 0, 0.85)",
    "0px 72px 144px rgba(0, 0, 0, 0.9)",
    "0px 76px 152px rgba(0, 0, 0, 0.95)",
    "0px 80px 160px rgba(0, 0, 0, 1)",
    "0px 84px 168px rgba(0, 0, 0, 1)",
    "0px 88px 176px rgba(0, 0, 0, 1)",
    "0px 92px 184px rgba(0, 0, 0, 1)",
  ],
});

export default theme;
